<app-accounting-template
        [title]="title"
        [apiUrl]="apiUrl"
        [tableInfo]="info"
        [type]="'DELIVERED'"
        [rowActionsSettings]="AccountingRowActionsSettings"
        [topActionsSettings]="topActionsSettings"
        [filtersSettings]="filtersSettings"
></app-accounting-template>
